import { useParams } from "react-router-dom";
import { LandingPages0001 } from "./0001";
import { LandingPages0002 } from "./0002";
import { LandingPages0003 } from "./0003";
import { LandingPages0004 } from "./0004";
import { LandingPages0005 } from "./0005";
import { LandingPages0006 } from "./0006";
import { LandingPages0007 } from "./0007";
import { LandingPages0008 } from "./0008";
import { useContextLandingPages } from "src/Contexts/LandingPageContext/LandingPagesContext";
import { useEffect } from "react";

type LandingPage = {
  id: string;
  titleInternal: string; // n vai usar esse title para renderizar
  landingPageComponent: React.ReactNode;
};

export const listLandingPagesRoot: LandingPage[] = [
  {
    id: "97c1d1c5-fbf4-4b59-92a0-63839fd05b44",
    titleInternal: "Economize no seu plano de Saúde",
    landingPageComponent: <LandingPages0001 />,
  },
  {
    id: "bf6b016a-6441-433e-868c-cc2417f91410",
    titleInternal: "Vida Segura - Planos de Saúde",
    landingPageComponent: <LandingPages0003 />,
  },
  {
    id: "c8ba3e83-4951-4320-99db-08d70e15b3b0",
    titleInternal: "Plano de Saúde Ideal para Você",
    landingPageComponent: <LandingPages0002 />,
  },
  {
    id: "93e31319-b009-4a69-aa5e-a7df616a6a3d",
    titleInternal: "Plano de Saúde Ideal para Você",
    landingPageComponent: <LandingPages0004 />,
  },
  {
    id: "e842d0bc-7b82-496e-bb27-141d90b08d29",
    titleInternal: "Plano de Saúde Ideal para Você",
    landingPageComponent: <LandingPages0005 />,
  },
  {
    id: "c7c19b3c-51f1-422e-a84e-27d2c94bb0f9",
    titleInternal: "Plano de Saúde Ideal para Você",
    landingPageComponent: <LandingPages0006 />,
  },

  {
    id: "93e11319-b009-4a69-aa5e-a7df456a6a3d",
    titleInternal: "Plano de Saúde Ideal para Você",
    landingPageComponent: <LandingPages0007 />,
  },
  {
    id: "bf6b016a-32312-433e-868c-cc2417f91410",
    titleInternal: "Plano de Saúde Ideal para Você",
    landingPageComponent: <LandingPages0008 />,
  },
];

export const LandingPages = () => {
  const { idLandingPage, idTenant } = useParams();

  const { setIdLandingPage, setIdTenant } = useContextLandingPages();

  useEffect(() => {
    setIdLandingPage(idLandingPage || "");
    setIdTenant(idTenant || "");
  }, [idLandingPage, idTenant]);

  const landingPageComponent = listLandingPagesRoot.find(
    (item) => item.id === idLandingPage
  )?.landingPageComponent;

  return <>{landingPageComponent}</>;
};
